var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6635 5.32006C11.6635 5.40794 11.6491 5.49033 11.6203 5.56722C11.5914 5.64411 11.543 5.71551 11.4748 5.78142L6.94657 10.1314C6.80935 10.2632 6.64652 10.3291 6.45807 10.3291C6.26962 10.3291 6.10656 10.2632 5.96888 10.1314C5.83166 9.99956 5.76305 9.84577 5.76305 9.67002C5.76305 9.49426 5.83166 9.34048 5.96888 9.20866L9.33075 5.97915L1.64648 5.97915C1.45209 5.97915 1.292 5.91588 1.16622 5.78933C1.04043 5.66279 0.977539 5.50637 0.977539 5.32006C0.977539 5.13332 1.04318 4.97668 1.17445 4.85014C1.30572 4.72359 1.46878 4.66054 1.66363 4.66098L9.33075 4.66098L5.96888 1.43147C5.83166 1.29965 5.76305 1.14586 5.76305 0.970109C5.76305 0.794353 5.83166 0.640569 5.96888 0.508752C6.1061 0.376935 6.26916 0.311026 6.45807 0.311026C6.64697 0.311026 6.80981 0.376935 6.94657 0.508752L11.4748 4.85871C11.5434 4.92461 11.5921 4.99601 11.6209 5.07291C11.6498 5.1498 11.6639 5.23219 11.6635 5.32006Z",
    fill: "#561212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector2.566937fdb502a2b2fc4f4fea66c809de.svg";
export { ForwardRef as ReactComponent };